
export default {
  name: 'CallUs',
  computed: {
    phoneNumber() {
      return (
        {
          'parkos.be': '+32 2588 97 47',
          'parkos.de': '+49 800 1810 516',
        }[this.$store.state.language.domain] || '050 808 0177'
      );
    },
  },
  methods: {
    openModal() {
      this.$emit('openModal');
    },
  },
};
